<template>
    <!-- <option v-if="parseFloat(balance)>0" :value="currency" :selected="currency==defaultCcy?true:false">{{ currency }} - Balance : {{ parseFloat(balance).toFixed(2) }}</option> -->
    <option v-if="(currency && !notzero) || (notzero==true && balance>0)" :value="currency" :selected="currency==defaultCcy?true:false">{{currency}} {{ mapping_currency[currency]?" - "+mapping_currency[currency]:'' }} <span v-if="!hidebalance">- Balance : <span v-if="balance && parseFloat(balance)>0"> {{ parseFloat(balance).toFixed(2) }}</span><span v-else>0.00</span></span></option>
</template>

<script>
import Account from '@/services/Account';
import Global from '@/services/Global';
export default{
    data(){
        return{
            balance :''
        }
    },
    props:['currency','userNo','defaultCcy',"mapping_currency","notzero","hidebalance"],
    methods:{
        getPrice(amount){
            return Global.addCommas(amount);
        },
    },
    mounted(){
        Account.getBalance({
            "userNo":this.userNo,
            "ccy":this.currency
        }).then((response)=>{
            let data = response.data.data.data;
            this.balance=data.availableBal;
        });
    }
}
</script>